module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pugin-group"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.cards), function(card, index) {
    return _c('md-layout', {
      key: card.id,
      staticClass: "plugin-card",
      attrs: {
        "md-flex": "33"
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToPlugin(card.link)
        }
      }
    }, [_c('plugin-card', {
      attrs: {
        "name": card.name,
        "desc": card.desc,
        "bg-color": card.bgColor
      }
    })], 1)
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-235cdfce"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 340
// module chunks = 1